// The teaching content, gathered. One file per group in ./learnContent/; the questions added after the
// first batch sit in ./learnContent/more/ and are appended, so the seed's ids (UUIDv5 of the slug, the
// format and the position) of what already exists never move.
import type { ComboContent, PatternContent, Quiz } from './learnContent/types'
import { CREATIONAL_AND_EARLY_STRUCTURAL } from './learnContent/groupA'
import { STRUCTURAL_AND_EARLY_BEHAVIOURAL } from './learnContent/groupB'
import { BEHAVIOURAL } from './learnContent/groupC'
import { COMBO_CONTENT } from './learnContent/combos'
import { MORE_A } from './learnContent/more/groupA'
import { MORE_B } from './learnContent/more/groupB'
import { MORE_C } from './learnContent/more/groupC'
import { MORE_COMBOS } from './learnContent/more/combos'

const MORE: Record<string, Quiz[]> = { ...MORE_A, ...MORE_B, ...MORE_C }

export const TEACHING: PatternContent[] = [
  ...CREATIONAL_AND_EARLY_STRUCTURAL,
  ...STRUCTURAL_AND_EARLY_BEHAVIOURAL,
  ...BEHAVIOURAL,
].map((t) => ({ ...t, quizzes: [...t.quizzes, ...(MORE[t.slug] ?? [])] }))
export const COMBOS: ComboContent[] = COMBO_CONTENT.map((c) => ({
  ...c,
  quizzes: [...c.quizzes, ...(MORE_COMBOS[c.key] ?? [])],
}))
export const teachingFor = (slug: string) => TEACHING.find((t) => t.slug === slug)
